import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
};

const ExperienceCell = () => {
  const { t } = useTranslation();

  const experiences = [
    {
      title: t("experience.title1"),
      company: t("experience.result1"),
      period: t("experience.subTitle1"),
    },
    {
      title: t("experience.title2"),
      company: t("experience.result2"),
      period: t("experience.subTitle2"),
    },
    {
      title: t("experience.title5"),
      company: t("experience.result5"),
      period: t("experience.subTitle5"),
    },
    {
      title: t("experience.title4"),
      company: t("experience.result4"),
      period: t("experience.subTitle4"),
    },
  ];

  return (
    <motion.div
      variants={item}
      className="bento-cell p-5 lgl:p-6 flex flex-col gap-4
                 lgl:col-start-1 lgl:col-end-7 lgl:row-start-8 lgl:row-end-10
                 md:col-span-2"
    >
      <h3 className="text-lg font-bold text-white font-titleFont">
        {t("bento.experience.title")}
      </h3>

      <div className="flex flex-col gap-3">
        {experiences.map((exp, i) => (
          <div
            key={i}
            className="flex items-start gap-3 group"
          >
            <div className="flex flex-col items-center mt-1.5">
              <div className="w-2 h-2 rounded-full bg-designColor/60 group-hover:bg-designColor transition-colors" />
              {i < experiences.length - 1 && (
                <div className="w-px h-full bg-white/10 mt-1" />
              )}
            </div>
            <div className="flex-1 pb-3">
              <div className="flex items-center justify-between gap-2">
                <h4 className="text-sm font-medium text-white">{exp.title}</h4>
                <span className="text-xs text-gray-600 whitespace-nowrap">{exp.period}</span>
              </div>
              <span className="text-xs text-designColor/80">{exp.company}</span>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default ExperienceCell;
